import React, {useEffect} from "react";
import {Col, Row} from 'reactstrap';
import {GetRouterQuery} from 'components/Utils/GetRouterQuery';
import {getInvoice} from "store/actions/Billing";
import {RootState} from "store/store";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import PageMeta from "components/PageMeta";
import InvoiceStatusCard from "./InvoiceStatusCard";
import InvoiceInfoSummaryCard from "./InvoiceInfoSummaryCard";
import InvoiceContentCard from "./InvoiceContentCard";
import InvoiceContentAddCard from "./InvoiceContentAddCard";
import InvoiceEmails from "./InvoiceEmails";
import {InvoiceState} from 'store/reducers/Invoices';
import {Account} from "models/Account";
import * as api from "services/Api";
import {useState} from "react";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

import "./InvoiceDetail.scss";

interface Props {
    invoiceState: InvoiceState;
}

interface Actions {
    getInvoice: (id: string) => void;
}

const InvoiceDetail: React.FC<Props & Actions> = ({ getInvoice, invoiceState }) => {
    const {t} = useOfficeTranslation();

    const { id } = GetRouterQuery<{ id: string }>()
    const [accounts, setAccounts] = useState<Account[]>([])

    useEffect(() => {
        api.getAccounts().then(setAccounts)
        getInvoice(id)
    }, [getInvoice, id])

    const invoice = invoiceState.getInvoiceById(id)

    if (invoice === null) {
        return <></>
    }

    return (
        <div className="page-content invoice-detail">
            <PageMeta title={`${t("common.invoice")} ${invoice.GetDisplayName()}`} />
            <Row>
                <Col md={6} xl={3}>
                    <InvoiceInfoSummaryCard invoice={invoice} accounts={accounts} />
                    <InvoiceStatusCard invoice={invoice} />
                    <InvoiceEmails invoice={invoice} />

                </Col>
                <Col md={6} xl={9}>
                    <InvoiceContentCard invoice={invoice} />
                    <InvoiceContentAddCard invoice={invoice} />
                </Col>
            </Row>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        invoiceState: state.Invoices,
    };
};


const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ getInvoice }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetail);
